var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-4"},[_c('div',{staticClass:"bg w-[280px] text-center rounded-md text-white py-2 mt-2 font-calibri font-bold"},[_vm._v(" "+_vm._s(_vm.$route.meta.title)+" ")]),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }